import { useContext, useState, useEffect, useRef } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import { DarkModeContext } from "../context/DarkModeContext";

import { motion } from "framer-motion";
import gsap from "gsap";

function AppLayout() {
  const { darkMode } = useContext(DarkModeContext);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const layoutRef = useRef(null);
  const location = useLocation();

  // 🔥 Page Fade Animation
  useEffect(() => {
    gsap.fromTo(
      layoutRef.current,
      { opacity: 0 },
      { opacity: 1, duration: 0.5 }
    );
  }, []);

  return (
    <div
      ref={layoutRef}
      className={`${
        darkMode ? "bg-gray-900 text-gray-100" : "bg-gray-50 text-gray-900"
      } min-h-screen overflow-x-hidden`}
    >
      {/* 🔥 Navbar */}
      <motion.div
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
      >
        <Navbar onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      </motion.div>

      {/* 🔥 Layout */}
      <div className="flex relative">

        {/* 🔥 Overlay (mobile only) */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* 🔥 Sidebar */}
        <Sidebar
          isOpen={sidebarOpen}
          closeSidebar={() => setSidebarOpen(false)}
        />

        {/* 🔥 Main Content */}
        <motion.main
          key={location.pathname}
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="flex-1 w-full p-4 sm:p-6 md:p-8"
        >
          <Outlet />
        </motion.main>
      </div>
    </div>
  );
}

export default AppLayout;